(async() => {
while(!window.hasOwnProperty("jQuery")||!jQuery.fn.validate||!jQuery.fn.mask) {
    await new Promise(resolve => setTimeout(resolve, 100));
}


'use strict';
var $ = jQuery;

var _calc = {

  init: function () {
    _calc.setCalc();
  },

  runCalc: function(els){
    var res = false,
    s = els.scale,
    temp = parseFloat(els.temp.val()),
    zero = parseFloat(els.zero.val());if ((temp != "") && (s.is(':checked'))) {
      temp = parseFloat((temp-32.0000000001)/1.8);
    }

    if(zero>0){
      if(temp>=0){
        res = zero * (1 + 3.9083 * Math.pow(10, -3) * temp + -5.775 * Math.pow(10, -7) * Math.pow(temp, 2))
      }
      else if(temp<0){
        res = zero * (1 + 3.9083 * Math.pow(10, -3) * temp + -5.775 * Math.pow(10, -7) * Math.pow(temp, 2) + -4.183 * Math.pow(10, -12) * (temp - 100) * Math.pow(temp, 3))
      }
    }
    $("#calcRes").text((res!==false)?res.toFixed(2):'');
  },
  setCalc: function(){
    var els = {
      form: $("#resistCalc"),
      scale : $('#calcScale'),
      zero: $('#calcZero'),
      temp: $('#calcTemp')
    };
    $.validator.addMethod("digitsonly", function(value, element) {
      return this.optional(element) || /^[0-9.-]+$/i.test(value);
    }, "Digits only");
    els.temp.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.-]/, optional: true}}});
    els.zero.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});

    els.form.validate({
      rules: {
        "calcTemp": {
          digitsonly: true,
          required: true
        },
        "calcZero": {
          digitsonly: true,
          required: true
        }
      },
      submitHandler: function(form) {
        form.preventDefault;
        _calc.runCalc(els);
        return false;
      }
    });
  }
};

$(document).ready(_calc.init);
})();
